var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "-10 -20 20 20",
    stroke: "white",
    strokeLinejoin: "round",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.723-11.355-.438-4.234h1.512a.86.86 0 0 0 .859-.86v-1.718a.86.86 0 0 0-.86-.86h-9.738a.86.86 0 0 0-.86.86v1.717c0 .475.385.86.86.86h1.511l-.439 4.235c-1.737.808-3.078 2.256-3.078 4.073 0 .475.385.86.86.86h4.868v3.724c0 .044.01.088.03.128l.86 1.718a.286.286 0 0 0 .512 0l.86-1.718c.02-.04.03-.084.03-.128v-3.725h4.87a.86.86 0 0 0 .859-.86c0-1.832-1.36-3.273-3.079-4.072Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotation);
export default __webpack_public_path__ + "static/media/annotation.0bf523606a5e14bc7d530bdc7d9139d0.svg";
export { ForwardRef as ReactComponent };